import React, { useCallback, useEffect, useState } from 'react';
import Toolbar from './Toolbar';
import Pagination from 'reusable/pagination';
import DriverTable from './DriverTable';
import axiosInstance from 'config/axiosInstance';

const DriverManagement: React.FC = () => {
  const rowsPerPage = 10;
  const [searchValue, setSearchValue] = useState('');
  const [sortValue, setSortValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [driver, setDriver] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchDriverData = useCallback(async () => {
    setLoading(true);
    try {
      let apiUrl = '/v1/drivers/with_submission_and_exceed/';
      apiUrl += `?order_by=${sortValue}&page=${currentPage}&page_size=10&search=${searchValue}`;
      const response = await axiosInstance.get(apiUrl);
      setDriver(response.data.results);
      setCount(response.data.count);
    } catch (error) {
      console.error('Failed to fetch driver data', error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchValue, sortValue]);

  useEffect(() => {
    fetchDriverData();
  }, [fetchDriverData]);

  const handleSortChange = (sortValue: string) => {
    setSortValue(sortValue);
    setCurrentPage(1);
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    setCurrentPage(1);
  };

  const handlePageChange = (value: number) => {
    setCurrentPage(value);
  };

  return (
    <section className="bg-white rounded-md p-4 space-y-4">
      <div className="flex flex-row justify-between w-full">
        <Toolbar
          searchValue={searchValue}
          sortValue={sortValue}
          currentPage={currentPage}
          onSearchChange={handleSearchChange}
          onSortChange={handleSortChange}
          onPageChange={handlePageChange}
          driverData={driver}
        />
      </div>
      {/* Loading Indicator */}
      {loading ? (
        <div
          className="flex justify-center items-center"
          style={{ height: '73vh' }}
        >
          <div>Loading...</div>
        </div>
      ) : (
        <div>
          <DriverTable driver={driver} />
        </div>
      )}
      {/* Pagination Section */}
      <div>
        <Pagination
          allRows={count}
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </section>
  );
};

export default DriverManagement;